module.exports = __webpack_public_path__ + "img/11.83befa8f.png";